module.exports = __webpack_public_path__ + "sprstatic/img/xin (1).7232b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xin/xin (1).png
// module id = Yxxr
// module chunks = 2